import React from 'react';
import styles from './Features.module.scss';

const SocialTab = () => (
  <div>
    <div className={styles.FeaturesTab}>
      <div className={styles.Container}>
        <h2>Connect with others outside of your events.</h2>
        <p>
          We’re here to help you create memories at events with your friends and
          make new connections along the way.
        </p>
        <div className={styles.SectionHeadline}>
          <img src="/img/illustrations/landing/news-feed.png" alt="News Feed" />
          <div className={styles.Description}>
            <h2>News Feed</h2>
            <p>
              From events to money transfers, see what your friends are up to!
            </p>
          </div>
        </div>
        <div className={styles.SectionHeadlineReverse}>
          <img
            src="/img/illustrations/landing/user-profile.png"
            alt="User Profile"
          />
          <div className={styles.Description}>
            <h2>User Profiles</h2>
            <p>
              Get to know other Bounce users, see each other&apos;s common
              interests and make new friends!
            </p>
          </div>
        </div>
        <div className={styles.SectionHeadline}>
          <img
            src="/img/illustrations/landing/event-groupchat.png"
            alt="Event Groupchat"
          />
          <div className={styles.Description}>
            <h2>Event Group Chats</h2>
            <p>Break the ice with fellow guests through event group chats!</p>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.Journey}>
      <div className={styles.Container}>
        <h2>
          From the pre-event to post-event stages, we are always there for you.
        </h2>
        <div className={styles.JourneyLine}>
          <div className={styles.Stage}>
            <img
              src="/img/illustrations/landing/journey-icon-1.png"
              alt="Social"
            />
            <h4>Discover an event on the Bounce event feed</h4>
          </div>
          <div className={styles.Line}>
            <img src="/img/illustrations/landing/line.svg" alt="" />
          </div>

          <div className={styles.Stage}>
            <img
              src="/img/illustrations/landing/journey-icon-2.png"
              alt="Social"
            />
            <h4>Meet new people in the pre-event groupchats</h4>
          </div>
          <div className={styles.Line}>
            <img src="/img/illustrations/landing/line.svg" alt="" />
          </div>
          <div className={styles.Stage}>
            <div>
              <img
                style={{ paddingRight: '10px' }}
                src="/img/illustrations/landing/journey-icon-3.png"
                alt="Social"
              />
              <img
                src="/img/illustrations/landing/journey-icon-3-1.png"
                alt="Social"
              />
            </div>
            <h4>Discover similar interests on quick view profiles</h4>
          </div>
          <div className={styles.Line}>
            <img src="/img/illustrations/landing/line.svg" alt="" />
          </div>
          <div className={styles.Stage}>
            <img
              src="/img/illustrations/landing/journey-icon-4.png"
              alt="Social"
            />
            <h4>Add each other on other social media platforms</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SocialTab;
